import {
  FishingReport,
  RecommendedProductFamily,
  TechniqueFull,
  WaterbodyDetail,
} from '@omniafishing/core';
import React from 'react';
import { isPending, LoadingState } from '../../../../constants/loading_state';
import { useResponsive } from '../../../../hooks/use_responsive';
import { ContentWrapper } from '../../../content_wrapper/content_wrapper';
import Loading from '../../../loading/loading';
import { TechniqueOverflowMenu } from '../../../technique_overflow_menu/technique_overflow_menu';
import { useWaterbodyState } from '../../waterbody_detail_lib/use_waterbody_state';
import { TechniqueCarousels } from './technique_carousels';
import { useQueryString } from '../../../../hooks/use_query_string';
import { WaterbodyDetailQueryParams } from '../../waterbody_detail';
import styles from './waterbody_detail_top_techniques.less';

export interface TechniqueFullWithReportCount extends TechniqueFull {
  reportCount: number;
}

interface WaterbodyDetailTopTechniquesProps {
  fishingReports: FishingReport[];
  recommendedProductFamilies: RecommendedProductFamily[];
  selectedTechnique: TechniqueFull;
  recommendationsLoadingState: LoadingState;
  topTechniquesOrdered: TechniqueFullWithReportCount[];
  waterbody: WaterbodyDetail;
}

export const WaterbodyDetailTopTechniques = (props: WaterbodyDetailTopTechniquesProps) => {
  const {
    fishingReports,
    selectedTechnique,
    recommendationsLoadingState,
    recommendedProductFamilies,
    topTechniquesOrdered,
    waterbody,
  } = props;

  const { selectedSeasonGroup, selectedSpecies } = useWaterbodyState({
    waterbody,
  });
  const { getCurrentQuery } = useQueryString();
  const currentQuery = getCurrentQuery<WaterbodyDetailQueryParams>();
  const webAnalyticsLakeClickArgs = {
    season: currentQuery.season_group || selectedSeasonGroup?.name,
    species: currentQuery.species || selectedSpecies?.name,
    technique: currentQuery.technique,
    waterbody_slug: waterbody.url_slug,
  };

  const hasTopTechniques = topTechniquesOrdered.length > 0;
  const { isDesktop } = useResponsive();
  return (
    <ContentWrapper>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionHeading}>
          <h2>Top Fishing Techniques </h2>
          <span>{`for ${selectedSpecies.display_name} + ${selectedSeasonGroup.display_name}`}</span>
        </div>
        {isDesktop && (
          <p>{`Choose from techniques based on ${waterbody.primary_name} fishing reports.`}</p>
        )}
      </div>

      <div className={styles.sectionWrapper}>
        {hasTopTechniques && (
          <TechniqueOverflowMenu
            topTechniques={topTechniquesOrdered}
            webAnalyticsLakeClickArgs={webAnalyticsLakeClickArgs}
            selectedSeasonGroup={selectedSeasonGroup}
            selectedSpecies={selectedSpecies}
            selectedTechnique={selectedTechnique}
            context={'waterbody'}
          />
        )}
        <div>
          {isPending(recommendationsLoadingState) ? (
            <Loading text="Loading Recommended Products" className={styles.loading} />
          ) : (
            <div>
              <TechniqueCarousels
                recommendedProductFamilies={recommendedProductFamilies}
                fishingReports={fishingReports}
                waterbodyDetail={waterbody}
                selectedTechnique={selectedTechnique}
              />
            </div>
          )}
        </div>
      </div>
    </ContentWrapper>
  );
};
